export type MeasurementSystem = "US" | "METRIC";

export const conversions = {
  inchesToCm: (inches: number): number => inches * 2.54,
  cmToInches: (cm: number): number => cm / 2.54,

  lbsToKg: (lbs: number): number => lbs * 0.453592,
  kgToLbs: (kg: number): number => kg / 0.453592,

  formatLength: (value: number, system: MeasurementSystem): number => {
    return Math.round(value * 10) / 10;
  },

  formatWeight: (value: number, system: MeasurementSystem): number => {
    return Math.round(value * 10) / 10;
  },
};

export const getUnits = (system: MeasurementSystem) => ({
  length: system === "US" ? "inches" : "centimeters",
  lengthAbbr: system === "US" ? "in" : "cm",
  weight: system === "US" ? "pounds" : "kilograms",
  weightAbbr: system === "US" ? "lbs" : "kg",
  angle: "degrees",
  angleAbbr: "deg",
  frequency: "lifts/minute",
  frequencyAbbr: "lifts/min",
});

export const convertNioshData = (
  data: any,
  fromSystem: MeasurementSystem,
  toSystem: MeasurementSystem,
) => {
  if (fromSystem === toSystem) return data;

  const convertLength =
    fromSystem === "US" ? conversions.inchesToCm : conversions.cmToInches;

  const convertWeight =
    fromSystem === "US" ? conversions.lbsToKg : conversions.kgToLbs;

  const convertPosition = (position: any) => ({
    ...position,
    loadWeightLb: conversions.formatWeight(
      convertWeight(position.loadWeightLb),
      toSystem,
    ),
    horizontalDistanceIn: conversions.formatLength(
      convertLength(position.horizontalDistanceIn),
      toSystem,
    ),
    verticalHeightIn: conversions.formatLength(
      convertLength(position.verticalHeightIn),
      toSystem,
    ),
  });

  return {
    ...data,
    origin: convertPosition(data.origin),
    destination: convertPosition(data.destination),
  };
};
